/**
 * Custom Header JavaScript for RABROPAR Theme
 * Handles: Mega Dropdown, Category Bar, Scroll Effects
 */

/* ============================================================
 * Localization (Language / Currency) switcher
 * ------------------------------------------------------------
 * This store serves each language on its own URL subfolder
 * (e.g. /es/, /pt/) via Shopify Markets, so a locale COOKIE
 * alone does NOT switch the displayed language. The reliable
 * way is to navigate to Shopify's canonical localized URL,
 * which is published in the page <head> as:
 *   <link rel="alternate" hreflang="es" href="https://.../es/...">
 *
 * - Language: jump straight to the matching hreflang URL.
 * - Country/Currency: POST to /localization to set the cookie,
 *   then reload (currency is cookie-based on this store).
 * ============================================================ */
window.RABROPAR = window.RABROPAR || {};
window.RABROPAR.setLocale = function (opts) {
  opts = opts || {};

  // ---------- LANGUAGE ----------
  if (opts.locale) {
    var iso = String(opts.locale).toLowerCase();
    var isoBase = iso.split('-')[0];
    var links = document.querySelectorAll('link[rel="alternate"][hreflang]');
    var target = null;
    for (var i = 0; i < links.length; i++) {
      var hl = (links[i].getAttribute('hreflang') || '').toLowerCase();
      var hlBase = hl.split('-')[0];
      if (hl === iso || hlBase === isoBase) {
        target = links[i].getAttribute('href');
        break;
      }
    }
    if (target) {
      window.location.href = target;
      return;
    }
    // Fallback: insert the locale subfolder manually (strip any existing one)
    var path = window.location.pathname.replace(/^\/(?:[a-z]{2}(?:-[a-z]{2,3})?)(?=\/|$)/i, '') || '/';
    window.location.href = '/' + isoBase + path + window.location.search;
    return;
  }

  // ---------- COUNTRY / CURRENCY ----------
  if (opts.country) {
    var body = {
      return_to: window.location.pathname + window.location.search,
      country_code: opts.country,
    };
    function reload() {
      window.location.reload();
    }
    try {
      fetch('/localization', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      })
        .then(reload)
        .catch(reload);
    } catch (e) {
      reload();
    }
  }
};

(function() {
  // === Variables ===
  const catTrigger = document.getElementById('catTrigger');
  const megaWrap = document.getElementById('megaWrap');
  const megaDropdown = document.querySelector('.mega-dropdown');
  const catbar = document.querySelector('.catbar');
  const navEl = document.querySelector('.nav');
  const navHamburger = document.getElementById('navHamburger');

  let hideTimer = null;
  let triggerSource = 'catbar'; // 'catbar' or 'nav'

  // === Update Dropdown Position ===
  function updatePosition() {
    if (triggerSource === 'nav') {
      // When triggered from nav hamburger (scrolled state), position below sticky nav
      const navRect = navEl.getBoundingClientRect();
      megaDropdown.style.top = navRect.bottom + 'px';
    } else {
      // When triggered from catbar, position below catbar
      const rect = catbar.getBoundingClientRect();
      megaDropdown.style.top = rect.bottom + 'px';
    }
  }

  // === Show Dropdown ===
  function showDropdown(source) {
    clearTimeout(hideTimer);
    triggerSource = source || triggerSource;
    updatePosition();
    megaWrap.classList.add('active');
    if (navHamburger) navHamburger.classList.add('active');

    // Auto-activate first L1 item → first L2 → first L3
    var firstL1 = document.querySelector('.mega-sidebar-item');
    if (firstL1 && !firstL1.classList.contains('active')) {
      firstL1.dispatchEvent(new Event('mouseenter', { bubbles: true }));
    }
  }

  // === Hide Dropdown ===
  function hideDropdown() {
    megaWrap.classList.remove('active');
    if (navHamburger) navHamburger.classList.remove('active');
  }

  // === Schedule Hide ===
  function scheduleHide() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hideDropdown, 300);
  }

  // === Initialize Mega Dropdown Events ===
  if (catTrigger && megaWrap && megaDropdown) {
    // Trigger events (category bar)
    catTrigger.addEventListener('mouseenter', function() { showDropdown('catbar'); });
    catTrigger.addEventListener('mouseleave', scheduleHide);

    // Keep dropdown open when hovering over it
    megaDropdown.addEventListener('mouseenter', function() {
      clearTimeout(hideTimer);
    });
    megaDropdown.addEventListener('mouseleave', scheduleHide);

    // Nav hamburger trigger (when scrolled)
    if (navHamburger) {
      navHamburger.addEventListener('mouseenter', function() { showDropdown('nav'); });
      navHamburger.addEventListener('mouseleave', scheduleHide);
    }

    // Close when clicking outside
    document.addEventListener('click', function(e) {
      if (!megaWrap.contains(e.target) && !catTrigger.contains(e.target)) {
        hideDropdown();
      }
    });

    // Handle scroll to update position
    window.addEventListener('scroll', function() {
      if (megaWrap.classList.contains('active')) {
        updatePosition();
      }
    });

    // Handle resize to update position
    window.addEventListener('resize', function() {
      if (megaWrap.classList.contains('active')) {
        updatePosition();
      }
    });
  }

  // === L1 → L2 Sidebar Switching ===
  document.querySelectorAll('.mega-sidebar-item').forEach(function(item) {
    item.addEventListener('mouseenter', function() {
      const l1Id = this.getAttribute('data-l1');
      if (!l1Id) return;

      // Deactivate all L1 items
      document.querySelectorAll('.mega-sidebar-item').forEach(function(s) {
        s.classList.remove('active');
      });

      // Hide all L2 sidebars
      document.querySelectorAll('.mega-sub-sidebar').forEach(function(sb) {
        sb.classList.remove('active');
      });

      // Activate hovered L1 + show its L2
      this.classList.add('active');
      const l2sidebar = document.getElementById(l1Id);
      if (l2sidebar) {
        l2sidebar.classList.add('active');

        // Auto-activate first L2 item + its L3 panel
        const firstL2 = l2sidebar.querySelector('.mega-sub-item');
        if (firstL2) {
          document.querySelectorAll('.mega-sub-item').forEach(function(s) {
            s.classList.remove('active');
          });
          firstL2.classList.add('active');

          const l2Id = firstL2.getAttribute('data-l2');
          document.querySelectorAll('.mega-content-panel').forEach(function(p) {
            p.classList.remove('active');
          });
          const panel = document.getElementById(l2Id);
          if (panel) panel.classList.add('active');
        }
      }
    });
  });

  // === L2 → L3 Content Switching ===
  document.querySelectorAll('.mega-sub-item').forEach(function(item) {
    item.addEventListener('mouseenter', function() {
      const l2Id = this.getAttribute('data-l2');
      if (!l2Id) return;

      // Deactivate all L2 items in current sidebar
      const parent = this.closest('.mega-sub-sidebar');
      if (parent) {
        parent.querySelectorAll('.mega-sub-item').forEach(function(s) {
          s.classList.remove('active');
        });
      }

      // Hide all L3 panels
      document.querySelectorAll('.mega-content-panel').forEach(function(p) {
        p.classList.remove('active');
      });

      // Activate hovered L2 + show its L3
      this.classList.add('active');
      const panel = document.getElementById(l2Id);
      if (panel) panel.classList.add('active');
    });
  });

  // === Scroll Effect for Nav ===
  let lastScrollTop = 0;
  const scrollThreshold = 100;

  window.addEventListener('scroll', function() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > scrollThreshold) {
      navEl.classList.add('nav-scrolled');
    } else {
      navEl.classList.remove('nav-scrolled');
    }

    lastScrollTop = scrollTop;
  });

  // === Mobile Menu Toggle ===
  if (navHamburger) {
    navHamburger.addEventListener('click', function() {
      // On mobile (<=749px), open/close drawer instead of mega dropdown
      if (window.innerWidth <= 749) {
        var overlay = document.getElementById('mobileOverlay');
        if (overlay) {
          if (overlay.classList.contains('active')) {
            closeMobileDrawer();
          } else {
            openMobileDrawer();
          }
        }
        return;
      }

      this.classList.toggle('active');

      // Toggle mega dropdown on desktop
      if (megaWrap) {
        if (megaWrap.classList.contains('active')) {
          hideDropdown();
        } else {
          showDropdown('nav');
        }
      }
    });
  }

  // === Mobile Drawer Functions ===
  var overlay = document.getElementById('mobileOverlay');
  var drawer = document.getElementById('mobileDrawer');
  var closeBtn = document.getElementById('mobileDrawerClose');
  var stack = document.getElementById('mobileNavStack');

  var currentLevelEl = null;
  var levelStack = [];
  var navInitialized = false;

  function openMobileDrawer() {
    if (overlay) {
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
    if (navHamburger) navHamburger.classList.add('active');
  }

  function closeMobileDrawer() {
    if (overlay) {
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }
    if (navHamburger) navHamburger.classList.remove('active');
    if (navInitialized) {
      setTimeout(function() {
        if (stack) stack.innerHTML = '';
        levelStack = [];
        currentLevelEl = renderL1();
        if (stack) stack.appendChild(currentLevelEl);
      }, 400);
    }
  }

  if (closeBtn) closeBtn.addEventListener('click', closeMobileDrawer);
  if (overlay) {
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeMobileDrawer();
    });
  }

  // Close drawer on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeMobileDrawer();
      hideDropdown();
    }
  });

  // ---- Build mobile nav from existing mega-dropdown data ----
  if (stack) {
    var l1Items = document.querySelectorAll('.mega-sidebar-item');
    var categoryData = [];

    l1Items.forEach(function(l1El) {
      var l1Id = l1El.getAttribute('data-l1');
      // Extract text from the link element (was span, now <a>)
      var nameLink = l1El.querySelector('.mega-sidebar-link');
      var l1Name = nameLink ? nameLink.textContent.trim() : '';
      var l1Svg = l1El.querySelector('svg');
      var l1SvgHtml = l1Svg ? l1Svg.outerHTML : '';

      var l2Sidebar = document.getElementById(l1Id);
      var l2Items = [];
      if (l2Sidebar) {
        l2Sidebar.querySelectorAll('.mega-sub-item').forEach(function(l2El) {
          var l2Id = l2El.getAttribute('data-l2');
          // Get text from the link element (was span, now <a>)
          var nameLink2 = l2El.querySelector('.mega-sub-link');
          var l2Name = nameLink2 ? nameLink2.textContent.trim() : '';

          var l3Panel = document.getElementById(l2Id);
          var l3Items = [];
          if (l3Panel) {
            l3Panel.querySelectorAll('.mega-product-card').forEach(function(l3El) {
              var nameEl = l3El.querySelector('.prod-name');
              var iconEl = l3El.querySelector('.prod-img');
              var linkEl = l3El.closest('a');
              l3Items.push({
                name: nameEl ? nameEl.textContent.trim() : '',
                iconHtml: iconEl ? iconEl.innerHTML : '',
                url: linkEl ? linkEl.href : '#'
              });
            });
          }
          l2Items.push({ id: l2Id, name: l2Name, url: l2El.getAttribute('data-url') || '#', l3Items: l3Items });
        });
      }
      categoryData.push({ id: l1Id, name: l1Name, svgHtml: l1SvgHtml, url: l1El.getAttribute('data-url') || '#', l2Items: l2Items });
    });

    // ---- Render navigation levels ----
    function createLevelEl() {
      var el = document.createElement('div');
      el.className = 'mobile-nav-level';
      return el;
    }

    function renderL1() {
      var level = createLevelEl();
      level.classList.add('level-current');

      var header = document.createElement('div');
      header.style.cssText = 'padding:12px 20px 6px;font-size:12px;font-weight:700;color:#7A8FA8;text-transform:uppercase;letter-spacing:1px';
      header.textContent = 'CATEGORIES';
      level.appendChild(header);

      categoryData.forEach(function(cat, idx) {
        var item = document.createElement('div');
        item.className = 'mobile-nav-item';
        item.innerHTML = cat.svgHtml + ' <a href="' + cat.url + '" class="nav-text">' + cat.name + '</a><span class="arrow">\u203A</span>';
        // Arrow click drills to L2; link click navigates normally
        var arrow = item.querySelector('.arrow');
        if (arrow) {
          arrow.addEventListener('click', function(e) {
            e.stopPropagation();
            e.preventDefault();
            drillToL2(idx);
          });
        }
        level.appendChild(item);
      });

      return level;
    }

    function renderL2(l1Idx) {
      var cat = categoryData[l1Idx];
      var level = createLevelEl();

      var back = document.createElement('div');
      back.className = 'mobile-nav-back';
      back.innerHTML = '<svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg> <span class="back-text">' + cat.name + '</span>';
      back.addEventListener('click', function() {
        goBack();
      });
      level.appendChild(back);

      cat.l2Items.forEach(function(l2, idx) {
        var item = document.createElement('div');
        item.className = 'mobile-nav-item';
        item.innerHTML = '<a href="' + l2.url + '" class="nav-text">' + l2.name + '</a><span class="arrow">\u203A</span>';
        // Arrow click drills to L3; link click navigates normally
        var arrow = item.querySelector('.arrow');
        if (arrow) {
          arrow.addEventListener('click', function(e) {
            e.stopPropagation();
            e.preventDefault();
            drillToL3(l1Idx, idx);
          });
        }
        level.appendChild(item);
      });

      return level;
    }

    function renderL3(l1Idx, l2Idx) {
      var cat = categoryData[l1Idx];
      var l2 = cat.l2Items[l2Idx];
      var level = createLevelEl();

      var back = document.createElement('div');
      back.className = 'mobile-nav-back';
      back.innerHTML = '<svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg> <span class="back-text">' + l2.name + '</span>';
      back.addEventListener('click', function() {
        goBack();
      });
      level.appendChild(back);

      var title = document.createElement('div');
      title.className = 'mobile-nav-l3-title';
      title.textContent = l2.name;
      level.appendChild(title);

      if (l2.l3Items.length > 0) {
        var grid = document.createElement('div');
        grid.className = 'mobile-nav-l3-grid';
        l2.l3Items.forEach(function(l3) {
          var item = document.createElement('a');
          item.className = 'mobile-nav-l3-item';
          item.href = l3.url;
          item.innerHTML = '<div class="prod-icon">' + l3.iconHtml + '</div><div class="prod-name">' + l3.name + '</div>';
          grid.appendChild(item);
        });
        level.appendChild(grid);
      }

      return level;
    }

    // ---- Navigation stack management ----
    function showLevel(newEl, direction) {
      if (currentLevelEl) {
        currentLevelEl.classList.remove('level-current');
        currentLevelEl.classList.add(direction === 'forward' ? 'level-left' : 'level-right');
      }
      newEl.classList.add(direction === 'forward' ? 'level-right' : 'level-left');
      stack.appendChild(newEl);
      // Avoid forced synchronous layout (void newEl.offsetHeight); use rAF instead
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          newEl.classList.remove('level-left', 'level-right');
          newEl.classList.add('level-current');
        });
      });
      currentLevelEl = newEl;
    }

    function drillToL2(l1Idx) {
      var newEl = renderL2(l1Idx);
      levelStack.push(currentLevelEl);
      showLevel(newEl, 'forward');
    }

    function drillToL3(l1Idx, l2Idx) {
      var newEl = renderL3(l1Idx, l2Idx);
      levelStack.push(currentLevelEl);
      showLevel(newEl, 'forward');
    }

    function goBack() {
      if (levelStack.length === 0) return;
      var prevEl = levelStack.pop();
      if (currentLevelEl) {
        var oldEl = currentLevelEl;
        oldEl.classList.remove('level-current');
        oldEl.classList.add('level-right');
        setTimeout(function() {
          if (oldEl.parentNode === stack) stack.removeChild(oldEl);
        }, 400);
      }
      prevEl.classList.add('level-left');
      // Avoid forced synchronous layout (void prevEl.offsetHeight); use rAF instead
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          prevEl.classList.remove('level-left');
          prevEl.classList.add('level-current');
        });
      });
      currentLevelEl = prevEl;
    }

    // Initialize L1
    currentLevelEl = renderL1();
    stack.appendChild(currentLevelEl);
    navInitialized = true;
  }

  // === Search Form Enhancement ===
  const searchForm = document.querySelector('.search-form');
  const searchInput = document.querySelector('.search-input');

  if (searchForm && searchInput) {
    // Add loading state
    searchForm.addEventListener('submit', function(e) {
      if (searchInput.value.trim() === '') {
        e.preventDefault();
        searchInput.focus();
      }
    });

    // Add keyboard navigation
    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        this.value = '';
        this.blur();
      }
    });
  }

  // === Cart Badge Animation ===
  const cartBtn = document.querySelector('.cart-btn');
  const cartBadge = document.querySelector('.cart-badge');

  if (cartBtn && cartBadge) {
    cartBtn.addEventListener('mouseenter', function() {
      cartBadge.style.transform = 'scale(1.2)';
      setTimeout(() => {
        cartBadge.style.transform = 'scale(1)';
      }, 200);
    });
  }

  // === Locale Dropdown Toggle ===
  var localeBtn = document.getElementById('localeBtn');
  var localeDropdown = document.getElementById('localeDropdown');
  if (localeBtn && localeDropdown) {
    localeBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      localeDropdown.classList.toggle('active');
    });

    document.addEventListener('click', function(e) {
      if (!localeBtn.contains(e.target) && !localeDropdown.contains(e.target)) {
        localeDropdown.classList.remove('active');
      }
    });
  }

  // === Accessibility Improvements ===
  // Add keyboard support for mega menu
  document.querySelectorAll('.mega-sidebar-item, .mega-sub-item').forEach(function(item) {
    item.setAttribute('tabindex', '0');
    item.setAttribute('role', 'button');

    item.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.dispatchEvent(new Event('mouseenter'));
      }
    });
  });

  // === Touch Device Support ===
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  if (isTouchDevice) {
    // On touch devices, toggle dropdown on tap instead of hover
    if (catTrigger) {
      catTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        if (megaWrap.classList.contains('active')) {
          hideDropdown();
        } else {
          showDropdown('catbar');
        }
      });
    }

    // Add touch support for L1 items
    document.querySelectorAll('.mega-sidebar-item').forEach(function(item) {
      item.addEventListener('click', function(e) {
        // Let the link navigate if clicked on the link itself
        if (e.target.closest('.mega-sidebar-link')) return;
        e.preventDefault();
        this.dispatchEvent(new Event('mouseenter'));
      });
    });

    // Add touch support for L2 items
    document.querySelectorAll('.mega-sub-item').forEach(function(item) {
      item.addEventListener('click', function(e) {
        // Let the link navigate if clicked on the link itself
        if (e.target.closest('.mega-sub-link')) return;
        e.preventDefault();
        this.dispatchEvent(new Event('mouseenter'));
      });
    });
  }

  // === Performance Optimization ===
  // Debounce scroll and resize events
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  window.addEventListener('scroll', debounce(function() {
    // Scroll-related logic here
  }, 10));

  window.addEventListener('resize', debounce(function() {
    // Resize-related logic here
  }, 100));

  // === Vehicle Dropdown ===
  var vehicleBtn = document.getElementById('vehicleBtn');
  var vehicleDropdown = document.getElementById('vehicleDropdown');
  var vehicleOverlay = document.getElementById('vehicleOverlay');
  var vehicleClose = document.getElementById('vehicleDropdownClose');
  var vehicleSearch = document.getElementById('vehicleSearchInput');
  var vehicleBody = document.getElementById('vehicleDropdownBody');

  var vehicleData = window.__vehicleMachineData || [];
  var vehicleRendered = false;

  function buildVehicleDropdown(data) {
    if (!vehicleBody) return;
    vehicleBody.innerHTML = '';

    if (!data || !data.length) {
      vehicleBody.innerHTML = '<div class="vehicle-dropdown-loading">No equipment types found. Add entries in Shopify Admin → Content → Metaobjects → machine_type.</div>';
      return;
    }

    // Group by category
    var groups = {};
    var catOrder = [];
    data.forEach(function(item) {
      var cat = (item.category || 'Other Equipment Types').trim();
      if (!groups[cat]) { groups[cat] = []; catOrder.push(cat); }
      groups[cat].push(item);
    });

    // Sort items within each group
    Object.keys(groups).forEach(function(cat) {
      groups[cat].sort(function(a, b) { return a.name.localeCompare(b.name); });
    });

    // Sort categories alphabetically
    catOrder.sort(function(a, b) { return a.localeCompare(b, undefined, { sensitivity: 'base' }); });

    // Move 'Other' to end
    var otherIdx = catOrder.indexOf('Other Equipment Types');
    if (otherIdx > -1) { catOrder.splice(otherIdx, 1); catOrder.push('Other Equipment Types'); }

    // Build HTML
    catOrder.forEach(function(cat) {
      var group = document.createElement('div');
      group.className = 'vehicle-group';

      var title = document.createElement('div');
      title.className = 'vehicle-group-title';
      title.textContent = cat;
      group.appendChild(title);

      groups[cat].forEach(function(item) {
        var a = document.createElement('a');
        a.className = 'vehicle-group-item';
        a.href = item.url;
        a.setAttribute('data-vehicle-name', item.name.toLowerCase());

        var imgWrap = document.createElement('div');
        imgWrap.className = 'vehicle-group-item-img';
        if (item.img) {
          imgWrap.innerHTML = '<img src="' + item.img + '" alt="' + item.name + '" loading="lazy">';
        } else {
          imgWrap.innerHTML = '<svg class="vehicle-placeholder" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="5" width="20" height="10" rx="2"/><path d="M7 15v2"/><path d="M17 15v2"/><circle cx="12" cy="15" r="2"/></svg>';
        }

        var nameSpan = document.createElement('span');
        nameSpan.className = 'vehicle-group-item-name';
        nameSpan.textContent = item.name;

        a.appendChild(imgWrap);
        a.appendChild(nameSpan);
        group.appendChild(a);
      });

      vehicleBody.appendChild(group);
    });

    // Add no-results element
    var noRes = document.createElement('div');
    noRes.className = 'vehicle-no-results';
    noRes.id = 'vehicleNoResults';
    noRes.textContent = 'No equipment matching your search.';
    vehicleBody.appendChild(noRes);

    vehicleRendered = true;
  }

  function openVehicleDropdown() {
    if (!vehicleDropdown) return;
    if (!vehicleRendered && vehicleData.length > 0) {
      buildVehicleDropdown(vehicleData);
    }
    // Position dropdown relative to vehicle button
    if (vehicleBtn && window.innerWidth > 749) {
      var rect = vehicleBtn.getBoundingClientRect();
      vehicleDropdown.style.left = Math.max(8, rect.left) + 'px';
      vehicleDropdown.style.top = (rect.bottom + 8) + 'px';
      vehicleDropdown.style.right = 'auto';
      vehicleDropdown.style.bottom = 'auto';
      vehicleDropdown.style.width = '440px';
      vehicleDropdown.style.maxHeight = '480px';
      vehicleDropdown.style.borderRadius = '14px';
    }
    vehicleDropdown.classList.add('active');
    if (vehicleOverlay) vehicleOverlay.classList.add('active');
    if (vehicleBtn) vehicleBtn.classList.add('active');
    document.body.style.overflow = 'hidden';
    setTimeout(function() {
      if (vehicleSearch) vehicleSearch.focus();
    }, 100);
  }

  function closeVehicleDropdown() {
    if (!vehicleDropdown) return;
    vehicleDropdown.classList.remove('active');
    if (vehicleOverlay) vehicleOverlay.classList.remove('active');
    if (vehicleBtn) vehicleBtn.classList.remove('active');
    document.body.style.overflow = '';
    if (vehicleSearch) { vehicleSearch.value = ''; filterVehicleItems(''); }
  }

  function filterVehicleItems(query) {
    if (!vehicleBody) return;
    var q = (query || '').toLowerCase().trim();
    var items = vehicleBody.querySelectorAll('.vehicle-group-item');
    var groups = vehicleBody.querySelectorAll('.vehicle-group');
    var noRes = document.getElementById('vehicleNoResults');
    var anyVisible = false;

    items.forEach(function(item) {
      var name = (item.getAttribute('data-vehicle-name') || '').toLowerCase();
      if (!q || name.indexOf(q) > -1) {
        item.style.display = '';
        anyVisible = true;
      } else {
        item.style.display = 'none';
      }
    });

    // Hide empty groups
    groups.forEach(function(group) {
      var visibleItems = group.querySelectorAll('.vehicle-group-item[style*="display: none"]');
      var totalItems = group.querySelectorAll('.vehicle-group-item');
      if (visibleItems.length === totalItems.length) {
        group.style.display = 'none';
      } else {
        group.style.display = '';
      }
    });

    if (noRes) {
      noRes.classList.toggle('show', !anyVisible && q.length > 0);
    }
  }

  if (vehicleBtn) {
    console.log('[By Vehicle] Button found, attaching click listener');
    vehicleBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      console.log('[By Vehicle] Button clicked, dropdown active:', vehicleDropdown && vehicleDropdown.classList.contains('active'));
      if (vehicleDropdown && vehicleDropdown.classList.contains('active')) {
        closeVehicleDropdown();
      } else {
        openVehicleDropdown();
      }
    });
  } else {
    console.warn('[By Vehicle] Button #vehicleBtn NOT found in DOM');
  }

  if (vehicleClose) {
    vehicleClose.addEventListener('click', closeVehicleDropdown);
  }

  if (vehicleOverlay) {
    vehicleOverlay.addEventListener('click', closeVehicleDropdown);
  }

  if (vehicleSearch) {
    vehicleSearch.addEventListener('input', function() {
      filterVehicleItems(this.value);
    });
  }

  // Close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && vehicleDropdown && vehicleDropdown.classList.contains('active')) {
      closeVehicleDropdown();
    }
  });

  // === Initialize ===
  console.log('Custom Header initialized successfully');
})();